<template>
    <div>
        <div
            class="header credits-list-item flex flex-row items-center justify-between w-full text-xl md:text-base px-7 py-3 md:px-3"
        >
            <div
                class="w-full text-slate-600 text-left font-medium"
                v-text="t('index.credits_menu_label') + ':'"
            ></div>
            <BadgeCredits
                :value="parseInt(credits.total)"
                :badge-size="isSmallScreen ? 7 : 5"
            ></BadgeCredits>
        </div>
        <div
            v-for="item in listing"
            :key="item.label"
            class="credits-list-item flex flex-row items-center justify-between w-full text-base md:border-t md:border-solid md:border-slate-200 px-7 py-3 md:py-3 md:px-3"
        >
            <div
                class="w-full text-slate-600 text-left"
                v-text="item.label"
            ></div>
            <div
                :class="[
                    'flex flex-row items-center justify-end text-right',
                    {
                        'text-red-600': item.used,
                        'text-yellow-500': !item.used,
                    },
                ]"
                v-text="item.value"
            ></div>
        </div>
    </div>
</template>

<script>
import BadgeCredits from '@components/BadgeCredits';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'CreditsBreakdownList',
    components: {
        BadgeCredits,
    },
    props: {
        credits: {
            type: Object,
            required: true,
        },
        /**
         * true for SM screens
         */
        isSmallScreen: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('reward');
        return { t };
    },
    computed: {
        listing() {
            if (this.credits) {
                return [
                    {
                        label: this.t('index.breakdown.label_document_uploads'),
                        value:
                            this.credits.detailed.first_upload ||
                            0 + this.credits.detailed.additional_uploads ||
                            0 + this.credits.detailed.quest_credits_document_uploads ||
                            0,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_document_downloads'),
                        value: this.credits.detailed.downloads,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_flashcard_sets'),
                        value: this.credits.detailed.first_flashcard,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_flashcard_learners'),
                        value: this.credits.detailed.flashcard_learners,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_referred_users'),
                        value:
                            this.credits.detailed.referred_users + this.credits.detailed.quest_credits_referred_users ||
                            0,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_career'),
                        value: this.credits.detailed.quest_credits_career || 0,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_other'),
                        value: this.credits.detailed.other + this.credits.detailed.quest_credits_other || 0,
                        used: false,
                    },
                    {
                        label: this.t('index.breakdown.label_used'),
                        value: this.credits.used,
                        used: true,
                    },
                ];
            }
            return [];
        },
    },
};
</script>
